module.exports = __webpack_public_path__ + "static/media/Samsung.306d68a8.svg";